import { instance } from './_config.js'


const getTypeOfGoods = async (obj) => {
    try {
        const rs = await instance.get(`/type_of_goods`, obj)
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateTypeOfGood = async (obj) => {
    try {
        const rs = await instance.post(`type_of_goods`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteTypeOfGood = async (id) => {
    try {
        const rs = await instance.delete(`type_of_goods`, { data: { '_id': id }})
        if (rs.data) {
            return rs.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getTypeOfGoods, updateTypeOfGood, deleteTypeOfGood }